import React from 'react';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Game from '../Game'

function App() {

  const router = createBrowserRouter([
    {
      path: "/game/:game",
      element: <Game/>
    },
    {
      path: "/",
      element: <Game/>
    }
  ]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
